const features = [
  {
    id: "01",
    title: "Suivi automatique des dépenses",
    subtitle: "Compatible Google Sheets & Excel",
    imageUrl: "https://readdy.ai/api/search-image?query=Person%20typing%20on%20laptop%20with%20colorful%20auto-updating%20spreadsheet%20dashboard%20on%20screen%2C%20cozy%20home%20office%2C%20warm%20natural%20sunlight%20through%20window%2C%20minimalist%20cream%20interior%2C%20no%20text%20no%20logos%2C%20efficient%20organized%20workspace&width=800&height=600&seq=hbs-v2-feature-auto-001&orientation=landscape",
  },
  {
    id: "02",
    title: "Visualisation claire du budget mensuel",
    subtitle: "Budget",
    imageUrl: "https://readdy.ai/api/search-image?query=Tablet%20displaying%20vibrant%20pie%20charts%20and%20bar%20graphs%20of%20monthly%20budget%20categories%2C%20placed%20on%20minimalist%20wooden%20desk%20with%20plant%2C%20bright%20natural%20daylight%2C%20clean%20Scandinavian%20office%20aesthetic%2C%20no%20text%20no%20logos&width=800&height=600&seq=hbs-v2-feature-visual-002&orientation=landscape",
  },
  {
    id: "03",
    title: "Alternative puissante aux applications financières",
    subtitle: "Aucun abonnement requis",
    imageUrl: "https://readdy.ai/api/search-image?query=Smartphone%20and%20laptop%20side%20by%20side%20showing%20same%20financial%20dashboard%2C%20minimalist%20desk%20with%20coffee%20cup%2C%20morning%20sunlight%2C%20cream%20and%20beige%20modern%20interior%2C%20no%20text%20no%20logos%2C%20seamless%20multi-device%20experience&width=800&height=600&seq=hbs-v2-feature-alt-003&orientation=landscape",
  },
];

export default function FeatureGrid() {
  return (
    <section className="py-20 md:py-28 px-6 md:px-12 bg-background-100">
      <div className="max-w-[1400px] mx-auto">
        {/* Header */}
        <div className="flex flex-col lg:flex-row lg:items-start gap-8 md:gap-16 mb-16 md:mb-20">
          <div className="lg:w-32 flex-shrink-0">
            <p className="text-xs font-bold tracking-[0.3em] text-foreground-400 whitespace-nowrap font-sans">
              HIPO
            </p>
          </div>
          <h2 className="text-3xl md:text-5xl lg:text-6xl font-bold text-foreground-950 font-heading leading-[1.1] max-w-2xl">
            Pourquoi choisir Hipobuy Spreadsheet ?
          </h2>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {features.map((feature, idx) => (
            <div
              key={feature.id}
              className="relative rounded-3xl overflow-hidden min-h-[340px] group cursor-pointer"
            >
              <img
                src={feature.imageUrl}
                alt={feature.title}
                className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                title={`Hipobuy Spreadsheet - ${feature.title}`}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 via-foreground-950/15 to-transparent"></div>
              <div className="absolute top-5 left-5">
                <span className="inline-flex items-center gap-2 bg-foreground-950/50 backdrop-blur-sm text-background-50 text-xs font-medium px-3 py-1.5 rounded-full font-sans">
                  <span className="text-primary-400 font-bold">{feature.id}</span>
                  {feature.subtitle}
                </span>
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-6 md:p-8">
                <p className="text-background-50 text-lg md:text-xl font-bold font-sans leading-tight">
                  {feature.title}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}